import React, { useEffect, useState,useRef } from 'react';
import axios from 'axios';
import { useReactToPrint } from "react-to-print";
import {
  Box,
  Input,
  Table,
  TableCaption,
  Thead,
  Tbody,
  Tr,
  Th,
  Td,
  TableContainer,
  Button,useDisclosure,
  AlertDialog,
  AlertDialogBody,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogContent,
  AlertDialogOverlay,
  useToast,Card,CardBody,CardHeader,CardFooter,
  Select,Text,SimpleGrid,
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalCloseButton,
  ModalBody,
  ModalFooter,Image
} from "@chakra-ui/react";
import toast from 'react-hot-toast';
import * as XLSX from 'xlsx'
import { IoMdClose } from 'react-icons/io';


const KotbillPrintModal=({isOpen,onClose,data,onOpen})=>{
    console.log(data,'data')

    const componentRef = useRef();
    const handlePrint = useReactToPrint({
      content: () => componentRef.current,
    });
    const print=()=>{
        handlePrint();
    }
    const handleClose = () => {
        onClose();
      };
      const scroll='inside'

    return(
         <Modal  width='full' size='7xl' isOpen={isOpen} onClose={onClose} onOpen={onOpen} scrollBehavior={scroll}  >
              <ModalOverlay />
              <ModalContent bg='#f9f1e3'>
                <ModalHeader display='flex' justifyContent='space-between' alignItems='center'>
                    <Text>Bill Data- {data?.name}</Text>
                    <Button colorScheme='red' onClick={handleClose} ><IoMdClose/></Button></ModalHeader>
                    <ModalBody>
          {data ? <Card mt={10}  textAlign='center' boxShadow='dark-lg' ref={componentRef} width="794px" mx="auto" >
      <Text color='purple' fontSize='18px' fontFamily='sans-serif' mt={5}>Kot Bill Report</Text>
        <CardHeader display='flex' justifyContent='center' flexDirection='column' alignItems='center' gap={5} p={4} boxShadow='md'>
       
       
       
          <Box color='purple' fontSize='18px' fontFamily='sans-serif'  textAlign='center' >
          {/* {data.map((item)=>(<> 
           <Image alignItems='center' src={item.imageUrl} w='220px' h='100px' mb={2}
                           />
          <Text >{item.name}</Text>
          <Text >{item.adress}</Text>
          <Text>{item.phoneNo}</Text>
          <Text>{item.website}</Text>
          <Text>Email id:{item.email}</Text>
          <Text>Gst No:{item.gstNo}</Text>
          </> 
        ))} */}
          </Box>
        
           
        </CardHeader>
        <CardBody display='flex' justifyContent='space-between' p={3} textAlign='left' >
         <TableContainer width='full'>
                <Table size='sm' variant='striped' colorScheme='green'>
                  <TableCaption>Food Data</TableCaption>
                  <Thead>
                    <Tr>
                      <Th fontSize='8px'>Food Item</Th>
                      <Th fontSize='8px'>TableNo</Th>
                      <Th fontSize='8px'>Server Name</Th>
                      <Th fontSize='8px'>KotNo</Th>
                      <Th fontSize='8px'>Total Bill</Th>
                      <Th fontSize='8px'>Created At</Th>
                   
                    </Tr>
                  </Thead>
                  <Tbody>
                    {data?.map((order, index) => (
                      <Tr key={index}>
                        <Td><Table size='xsm' variant='striped' colorScheme='orange'>
                            <Thead>
                                <Tr>
                                    <Th fontSize='8px'>Food Item</Th>
                                    <Th fontSize='8px'>Quantity</Th>
                                    <Th fontSize='8px'>Price</Th>
                                </Tr>
                                {order.foodItem.map((item, index) => (
                                    <Tr key={index}>
                                        <Td fontSize='8px'>{item.name}</Td>
                                        <Td fontSize='8px'>{item.quantity}</Td>
                                        <Td fontSize='8px'>{item.price}</Td>
                                    </Tr>
                                ))}
                            </Thead>
                        </Table></Td>
                        <Td fontSize='8px'>{order.tableNo}</Td>
                        <Td fontSize='8px'>{order.serverName}</Td>
                        <Td fontSize='8px'>{order.kotNo}</Td>
                        <Td fontSize='8px'>{order.totalBilling}</Td>
                        <Td fontSize='8px'>{new Date(order.createdAt).toLocaleString('en-GB')}</Td>
                       
                      </Tr>
                    ))}
                  </Tbody>
                </Table>
              </TableContainer>
        </CardBody>
      
        
      </Card>:''}
     
      
      <Box display='flex' flexDirection='row' justifyContent='end' alignItems='center' gap='3'>
           <Button as='b' colorScheme='blue' onClick={print}>Print</Button>
           <Button as='b' colorScheme='blue' onClick={handleClose}>Close</Button>
      </Box>
      </ModalBody>
      </ModalContent>
      </Modal>
    )
}
export default KotbillPrintModal;